import formUtils from "@/utils/form-utils";

export default function checkIsValidId (id) {
    return formUtils.isValidId(id);
}
